/** HTML sanitization — strip dangerous tags while preserving safe formatting */
export function sanitizeHtml(html: string): string {
  return html
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, "")
    .replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, "$1")
    .replace(/on\w+="[^"]*"/gi, "")
    .replace(/on\w+='[^']*'/gi, "")
    .replace(/javascript:/gi, "");
}

/** Convert BBCode-style review text to plain text */
export function bbcodeToText(text: string): string {
  return text
    .replace(/\[h1\](.*?)\[\/h1\]/gi, "$1")
    .replace(/\[h2\](.*?)\[\/h2\]/gi, "$1")
    .replace(/\[h3\](.*?)\[\/h3\]/gi, "$1")
    .replace(/\[b\](.*?)\[\/b\]/gi, "$1")
    .replace(/\[i\](.*?)\[\/i\]/gi, "$1")
    .replace(/\[u\](.*?)\[\/u\]/gi, "$1")
    .replace(/\[strike\](.*?)\[\/strike\]/gi, "$1")
    .replace(/\[spoiler\](.*?)\[\/spoiler\]/gi, "[스포일러]")
    .replace(/\[url=([^\]]*)\](.*?)\[\/url\]/gi, "$2")
    .replace(/\[url\](.*?)\[\/url\]/gi, "$1")
    .replace(/\[img\](.*?)\[\/img\]/gi, "[이미지]")
    .replace(/\[list\]/gi, "")
    .replace(/\[\/list\]/gi, "")
    .replace(/\[\*\]/gi, "• ")
    .replace(/\[hr\]/gi, "")
    .replace(/\[\/?\w+[^\]]*\]/gi, "")
    .trim();
}
